import React from 'react';
import { Link } from 'react-router-dom';

const LicensePage = () => {
  return (
    <div className="legal-page">
      <div className="back-link-container">
        <Link to="/" className="back-link">&larr; Back to Home</Link>
      </div>

      <h1>License Information</h1>
      <p>Last Updated: [Date]</p>
      
      <h2>Software License</h2>
      <p>The software underlying the Magical Videos service is proprietary and confidential information owned by [Your Company Name/Your Name]. All rights are reserved.</p>
      <p>Your use of the service is subject to the terms outlined in our main Terms of Service/Policy page.</p>

      <h2>Generated Content</h2>
      <p>Content generated by users through the service ("Generated Content") is subject to the usage rights and restrictions outlined in our main Terms of Service/Policy.</p>
      <p>Typically, users retain certain rights to the content they generate, but [Your Company Name/Your Name] may retain a license to use, modify, or display Generated Content in connection with operating and promoting the service.</p>
      <p>Please refer to the main Policy page for detailed information on content ownership and licensing.</p>
      
      {/* Add specific license details if you use third-party libraries, fonts, etc. */}
      {/* Example: 
      <h2>Third-Party Licenses</h2>
      <p>This service may utilize third-party software or assets. Their respective licenses apply.</p>
      <ul>
        <li>[Library Name] - [License Type, e.g., MIT License] - [Link to License]</li>
      </ul> 
      */}
    </div>
  );
};

export default LicensePage; 